/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import React from 'react';
import { Avatar } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { StyledUser, StyledPopover } from './style';

type PopoverContentProps = {
  username?: string;
  company?: string;
  logout: VoidFunction;
};

const PopoverContent = ({ username, company, logout }: PopoverContentProps) => (
  <div className="header-user-popover">
    {username && (
      <p data-field="username">
        <span>{username}</span>
        <a
          href={`https://app.datayes.com/cloud-portal/#/myaccount/personalInfo?RelayState=${encodeURIComponent(
            window.location.href
          )}`}
          target="_blank"
        >
          <SettingOutlined />
        </a>
      </p>
    )}
    <p data-field="company">{company}</p>
    <ul>
      <li>
        <span onClick={() => logout()}>登出</span>
      </li>
    </ul>
  </div>
);

type HeaderUserProps = {
  isAnonymous?: boolean;
  username?: string;
  company?: string;
  userAvatar?: string;
  logout: VoidFunction;
  showLoginModal: VoidFunction;
  showRegisterModal: VoidFunction;
};

const HeaderUser = ({
  isAnonymous,
  username,
  company,
  userAvatar,
  logout,
  showLoginModal,
  showRegisterModal,
}: HeaderUserProps) => {
  if (isAnonymous) {
    return (
      <StyledUser>
        <span role="presentation" className="header-user-link" onClick={() => showLoginModal()}>
          登录
        </span>
        <span className="cutting-line">|</span>
        <span role="presentation" className="header-user-link" onClick={() => showRegisterModal()}>
          注册
        </span>
      </StyledUser>
    );
  }
  if (!username) {
    return null;
  }
  return (
    <StyledPopover
      content={<PopoverContent username={username} company={company} logout={logout} />}
      trigger="click"
      placement="bottomRight"
      getPopupContainer={(triggerNode) => triggerNode}
    >
      <div className="header-user">
        <Avatar src={userAvatar} className="header-user-avatar" />
      </div>
    </StyledPopover>
  );
};

export default HeaderUser;
